import React, { FC } from 'react'
import Icon from '../../Core/Iconography/Icon/Icon'
import Font from '../../Core/Typography/Font/Font'
import { StepProgressBarWrapper, List, WrapperCircle, Line, GenericCircle } from './StepProgressBar.styles'
import { StepProgressProps, OptionsListProps } from './types'

const StepProgressBar: FC<StepProgressProps> = props => {
  const { optionsList, onListClick, currentStep, progressIndex, applicationStatus } = props
  const loopList = Array.isArray(optionsList) && optionsList.length !== 0 ? optionsList.map((obj: OptionsListProps, index: number) => {
    const isComplete = obj?.state === 'complete' || obj?.state === 'warning'
    const isSameAsProgressIndex = progressIndex === index + 1
    const changeInitialStepToNotStarted = (isSameAsProgressIndex && !isComplete) ? 'not_started' : obj?.state
    const allowSignatureStep = optionsList.length - 1 === index && ['not_started', 'in_progress', 'submitted', 'aof_approved', 'generating_signature_pack'].includes(applicationStatus)

    return (
      <List
        as='li'
        key={index}
        state={obj?.state}
        justifyContent='flex-start'
        noClickCursor={allowSignatureStep}
        onClick={(e: React.MouseEvent<HTMLLIElement>) => {
          if(allowSignatureStep) {
            e.preventDefault()
            return
          }
          if (onListClick) onListClick(index)
        }}
      >
        <WrapperCircle
          state={(index === currentStep && !isComplete) ? 'in_progress' : changeInitialStepToNotStarted}
          noClickCursor={allowSignatureStep}
          justifyContent='center'
          alignItems='center'
        >
          {index !== optionsList.length - 1 ? <Line/> : ''}
          {
            allowSignatureStep
              ? <Icon size='s' color='dark' name='lock' />
              : (obj?.state !== 'complete' &&
                obj?.state !== 'warning' &&
                index === currentStep) ||
                obj?.state === 'not_started' ||
                obj?.state === 'in_progress'
                ? <Font tag='h5'>{index + 1}</Font>
                : <Icon
                  size='s'
                  color='blank'
                  name={obj?.state === 'complete' ? 'check' : 'warning'}
                />
          }
        </WrapperCircle>
        <Font tag='h6' ellipsis bold={index === currentStep ? true : false}>
          {obj?.label} {obj.unreadCommentsCount > 0 ? <GenericCircle /> : obj.commentsCount > 0 ? <GenericCircle emptyCircle/> : null}
        </Font>
      </List>
    )
  }) : null

  if (loopList === null) return null

  return (
    <StepProgressBarWrapper
      as='ul'
      flexDirection='column'
      justifyContent='flex-start'
      alignItems='flex-start'
    >
      {loopList}
    </StepProgressBarWrapper>
  )}

StepProgressBar.defaultProps = {
  optionsList: [],
  currentStep: 0
}

export default StepProgressBar
